import { queueTrackingEvent } from '@library/tracking-integration'

type DashboardActionTrackingEvent =
  | {
      action: 'view_all_upcoming_deliveries'
    }
  | {
      action: 'click_order_another_box'
    }
  | {
      action: 'click_get_help'
    }
  | {
      action: 'NativeReferFriendInterface Opened'
    }
  | {
      action: 'AppPromoSection Clicked'
    }

const dashboardActionTrackingEvents: Record<string, DashboardActionTrackingEvent | undefined> = {
  futureDeliveries: { action: 'view_all_upcoming_deliveries' },
  getHelp: { action: 'click_get_help' },
  orderBox: { action: 'click_order_another_box' },
  raf: { action: 'NativeReferFriendInterface Opened' },
}

export const useDashboardActionTracking = () => ({
  trackDashboardActionClick: (actionType: string) => {
    const trackingEvent = dashboardActionTrackingEvents[actionType]

    if (trackingEvent) {
      queueTrackingEvent<DashboardActionTrackingEvent>(trackingEvent)
    }
  },
  trackAppDownloadButtonClick: () => {
    queueTrackingEvent<DashboardActionTrackingEvent>({
      action: 'AppPromoSection Clicked',
    })
  },
})
